import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../environments/environment.production";
import { DefaultErrorMessage, ErrorMessages } from "../components/catalogoErrores/error-messages";
import {EstatusVehiculoResponseMoral} from '../pojos/estatusVehiculoResponseMorales'; // Asegúrate que la ruta sea correcta

@Injectable({
  providedIn: 'root'
})
export class ConsultarEstatusVehiculoMoralService {
  // Actualizado para apuntar al endpoint de consultarVehiculo
  private readonly endPoint = `${environment.HOST}/consultarEstatusVehiculoMoral`;

  constructor(
    private http: HttpClient,
    // private errorHandler: ErrorHandlerService // Servicio opcional para manejo centralizado
  ) {}

  consultarEstatusVehiculo(strNiv: string, strPlaca: string): Observable<EstatusVehiculoResponseMoral> {
    if (!strNiv?.trim()) {
      return throwError(() => this.createValidationError('NIV no puede estar vacío'));
    }
    if (!strPlaca?.trim()) {
      return throwError(() => this.createValidationError('Placa no puede estar vacía'));
    }

    const params = new HttpParams()
      .set('strNiv', strNiv)
      .set('strPlaca', strPlaca);

    // La lógica de la petición GET y el tipado con EstatusVehiculoResponseMoral es correcta.
    // HttpClient se encargará de mapear el JSON a la interfaz EstatusVehiculoResponse actualizada.
    return this.http.get<EstatusVehiculoResponseMoral>(this.endPoint, { params }).pipe(
      catchError(error => {
        const customError = {
          originalError: error,
          timestamp: new Date().toISOString(),
          // El manejo de mensajes de error se mantiene, asumiendo que la estructura del error del nuevo endpoint es similar
          // o que los mensajes genéricos son aceptables.
          userMessage: error.error?.descripcionCodigo ||
            ErrorMessages[error.error?.idCodigo] ||
            ErrorMessages[error.status] ||
            DefaultErrorMessage,
          context: {
            endpoint: this.endPoint,
            params: { strNiv, strPlaca }
          }
        };
        console.error(customError); // Cambiado a console.error para errores
        return throwError(() => customError);
      })
    );
  }

  private createValidationError(message: string): any {
    // Considerar devolver un objeto de error más estándar o específico de la aplicación
    return {
      type: 'VALIDATION_ERROR',
      message,
      userMessage: message, // Para consistencia con el `customError`
      timestamp: new Date().toISOString()
    };
  }
}
